/**
 * Logó feltöltés modal — használható a Számlák, Szállítólevelek és Beállítások oldalról
 */
import { useState, useRef } from 'react';
import { Button, Modal } from './ui';
import { useToast } from './ui/Toast';

export default function LogoUploadModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { toast } = useToast();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  async function handleUpload(file: File) {
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('logo', file);
      const tk = localStorage.getItem('accessToken');
      const res = await fetch('/api/company-profile/logo', {
        method: 'POST',
        headers: tk ? { Authorization: `Bearer ${tk}` } : {},
        body: fd,
      });
      const data = await res.json();
      if (res.ok) {
        toast('Logo feltoltve!', 'success');
        setPreview(URL.createObjectURL(file));
      } else {
        toast(data.error || 'Feltoltes sikertelen.', 'error');
      }
    } catch {
      toast('Feltoltes sikertelen.', 'error');
    } finally {
      setUploading(false);
    }
  }

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) handleUpload(file);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Ceglogo feltoltese">
      <div className="space-y-4">
        <div style={{ fontSize: '13px', color: 'var(--slate)', lineHeight: 1.6 }}>
          A logo megjelenik a szamlakon, szallitoleveleken es a rendszerben.
          PNG, JPG vagy WEBP, max 10 MB.
        </div>

        {preview && (
          <div style={{ textAlign: 'center', padding: '16px', background: 'var(--mist)', borderRadius: 'var(--r)' }}>
            <img src={preview} alt="Logo" style={{ maxWidth: '200px', maxHeight: '80px' }} />
          </div>
        )}

        <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" style={{ display: 'none' }} onChange={handleFileChange} />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '9px', paddingTop: '8px' }}>
          <Button variant="ghost" onClick={onClose}>Bezaras</Button>
          <Button loading={uploading} onClick={() => fileRef.current?.click()}>Logo kivalasztasa</Button>
        </div>
      </div>
    </Modal>
  );
}
